import { useCallback, useState, useEffect } from "react";
// import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./TopUp.module.css";
import config from "../../../config/config";
import axios from "axios";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";
// import {styles as typescaleStyles} from '@material/web/typography/md-typescale-styles.js';

const TopUp = ({
  isVisible,
  onClose,
  openNoti,
  resetAdmin,
  setAdmin,
  className = "",
}) => {
  const [TopupName, setTopupName] = useState("");
  const [TotalLimit, setTotalLimit] = useState();
  const [DailyLimit, setDailyLimit] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minDate, setMinDate] = useState("");
  const [Note, setNote] = useState("");
  const [errormsg, setErrorMsg] = useState({
    isInValidDaily: false,
    isInValidTotal: false,
    isDailyMorethanTotal: false,
    isAnyFieldEmpty: false,
    NameMaxLimitReach: false,
    InvalidEndDate: false,
    InvalidStartDate: false,
    DailyAmountIsInvalid: false,
    TotalAmountIsInvalid: false,
  });
  const [ErrorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    try {
      console.log("Fetching Detail");

      setTopupName(store?.TopUpName);
      setTotalLimit(store?.TopUpTotalLimit);
      setDailyLimit(store?.TopUpDailyLimit);
      setStartDate(store?.StartDate);
      setEndDate(store?.EndDate);
      setNote(store?.TopUpNote);
      console.log("Details Fetched");
    } catch (err) {
      console.log("error", err);
    }
  }, []);

  async function OnFramButtonClicked() {
    try {
      setErrorMsg({
        isInValidTotal: false,
        isInValidDaily: false,
        isDailyMorethanTotal: false,
        isAnyFieldEmpty: false,
        InvalidEndDate: false,
        InvalidStartDate: false,
        DailyAmountIsInvalid: false,
        TotalAmountIsInvalid: false,
      });
      console.log(
        "Info--->",
        "TopupName",
        TopupName,
        "TotalLimit",
        TotalLimit,
        "DailyLimit",
        DailyLimit,
        "startDate",
        startDate,
        "endDate",
        endDate,
        "TotalLimit",
        TotalLimit,
        "DailyLimit",
        DailyLimit
      );

      if (
        TopupName == "" ||
        TotalLimit == "" ||
        DailyLimit == "" ||
        startDate == "" ||
        endDate == "" ||
        !TotalLimit ||
        !DailyLimit
      ) {
        setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
        setErrorMessage("This field can't be empty.");
        return;
      }
      const nameRegex = /^[a-zA-Z0-9\s]+$/;
      if (!nameRegex.test(TopupName)) {
        setErrorMessage("Please enter a valid Topup name");
        console.log("name", name);

        setErrorMsg((prev) => ({ ...prev, invalidName: true }));
        return;
      }
      // if (Number(TotalLimit) <= 0) {
      //   setErrorMsg((prev) => ({ ...prev, isInValidTotal: true }));
      //   setErrorMessage("Limits Cannot be 0");
      //   return;
      // }
      // if (Number(DailyLimit) <= 0) {
      //   setErrorMsg((prev) => ({ ...prev, isInValidDaily: true }));
      //   setErrorMessage("Limits Cannot be 0");
      //   return;
      // }
      if (Number(DailyLimit) > Number(TotalLimit)) {
        setErrorMsg((prev) => ({ ...prev, isDailyMorethanTotal: true }));
        setErrorMessage("Daily Limit can't exceed Total period Limit");
        return;
      }
      if (Number(TotalLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, TotalAmountIsInvalid: true })); //
        setErrorMessage("Total Limit is Invalid.");
        return;
      }
      if (Number(DailyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, DailyAmountIsInvalid: true })); //
        setErrorMessage("Daily Limit is Invalid.");
        return;
      }

      if (!nameRegex.test(Note) && Note != "") {
        setErrorMessage("Please enter a valid note");
        console.log("name", name);

        setErrorMsg((prev) => ({ ...prev, invalidNote: true }));
        return;
      }
      let CurrentDate = getCurrentDate().replace("T", " ");
      CurrentDate = CurrentDate.replace("T", " ");
      if (startDate.includes("T")) {
        setStartDate(startDate.replace("T", " "));
      }
      if (endDate.includes("T")) {
        setEndDate(endDate.replace("T", " "));
      }
      console.log("startDate", startDate);
      console.log("CurrentDate", CurrentDate);

      if (
        startDate.replace("T", " ") < CurrentDate &&
        store.TopUpStatus != "active"
      ) {
        console.log("Date is Invalid ");
        setErrorMsg((prev) => ({ ...prev, InvalidStartDate: true }));
        setErrorMessage("Start Date can't be a past date");
        return;
      }

      if (endDate.replace("T", " ") < CurrentDate) {
        setErrorMsg((prev) => ({ ...prev, InvalidEndDate: true }));
        setErrorMessage("End Date can't be a past date");
        return;
      }
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      let obj = {
        ledger_label: store.Company_Id,
        user_id: store.userId,
        create_at: store.create_at,
        topup_name: TopupName.trim(),
        total_limit: TotalLimit,
        daily_limit: DailyLimit,
        note: Note != "" ? Note : "NA",
        start_date: startDate.replace("T", " "),
        end_date: endDate.replace("T", " "),
      };
      const url = `${config.node_api_endpoint}/cupi/admin/update_topup`;

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${url}`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((res) => {
          console.log("response", res);
          onClose();
          openNoti();
        })
        .catch((er) => {
          console.log(er);
          if (er.response.data.data == "start date cannot be in the past") {
            setErrorMsg((prev) => ({
              ...prev,
              InvalidStartDate: true,
            }));
            setErrorMessage("Start Date can't be a past date");
          }
          if (er.response.data.data == "End Date Cannot be in the past") {
            setErrorMsg((prev) => ({
              ...prev,
              InvalidEndDate: true,
            }));
            setErrorMessage("End Date can't be a past date");
          }
        });
    } catch (err) {
      console.log("Error", err);
    } finally {
    }
  }

  function getEndDate() {
    let todaydate = getCurrentDate();
    if (startDate > todaydate) {
      return startDate;
    }
    return todaydate;
  }

  function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    // Critical Fix: Use "T" instead of space
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const getCurrentDateTime = () => {
    const now = new Date();
    // Pad single digits with zero
    const pad = (n) => n.toString().padStart(2, "0");

    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const getEndDateMin = () => {
    // If startDate is already selected, min = startDate
    if (startDate) {
      return startDate; // already in "YYYY-MM-DDTHH:mm" format
    }

    // Otherwise, don't allow past dates/times
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");

    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          onClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        <div className={styles.addUserDetails}>Top-up</div>
        <div className={styles.frameWrapper}>
          <div className={styles.mobileMenuParent}>
            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={TopupName}
                label="Enter Topup name"
                required
                disabled={store.isUserGlobalViewAdmin || store.isUserViewAdmin}
                onChange={async (e) => {
                  setErrorMsg((prev) => ({ ...prev, invalidName: false }));
                  let value = e.target.value;
                  if (value.length > 50) {
                    setErrorMsg((prev) => ({
                      ...prev,
                      NameMaxLimitReach: true,
                    }));
                    setErrorMessage("Maximum Limit Reach");

                    // Await a 2-second delay before clearing the error
                    await new Promise((resolve) => setTimeout(resolve, 2000));

                    setErrorMsg((prev) => ({
                      ...prev,
                      NameMaxLimitReach: false,
                    }));
                    return;
                  }

                  // Clear error and update name if valid
                  setErrorMsg((prev) => ({
                    ...prev,
                    NameMaxLimitReach: false,
                  }));
                  setTopupName(e.target.value);
                }}
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                }}
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                  },
                }}
              />
              {(errormsg.NameMaxLimitReach || errormsg.invalidName) && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>{ErrorMessage}</div>
                </div>
              )}
              {errormsg.isAnyFieldEmpty && TopupName == "" && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>{ErrorMessage}</div>
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={TotalLimit}
                label="Set Total time period limit"
                required
                disabled={store.isUserGlobalViewAdmin || store.isUserViewAdmin}
                type="text" // ← Changed from "number" to "text"
                inputMode="numeric" // ← Ensures numeric keyboard on mobile
                pattern="[0-9]*" // ← Helps with HTML5 validation (optional but good)
                onChange={(e) => {
                  const value = e.target.value;

                  // Only allow empty string or digits
                  if (/^\d*$/.test(value)) {
                    setErrorMsg((prev) => ({
                      ...prev,
                      TotalAmountIsInvalid: false,
                    }));
                    setTotalLimit(value);
                  }
                  // If user types invalid char (like +, -, e), input is ignored
                }}
                variant="outlined"
                placeholder="Total time period limit" // Optional: helpful UX
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                  },
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  // Hide spinners completely
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "& input": {
                    MozAppearance: "textfield", // Firefox: removes arrows
                  },
                }}
              />
              {(errormsg.isInValidTotal || errormsg.TotalAmountIsInvalid) && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>{ErrorMessage}</div>
                </div>
              )}
              {errormsg.isAnyFieldEmpty && TotalLimit == "" && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>
                    "Please enter a valid daily limit "
                  </div>
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={DailyLimit}
                required
                disabled={store.isUserGlobalViewAdmin || store.isUserViewAdmin}
                type="text" // ← Change to "text" for full control
                inputMode="numeric" // ← Shows numeric keyboard on mobile
                label="Set daily Txn limit"
                placeholder="Daily Txn limit"
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only digits (and empty string)
                  if (/^\d*$/.test(value)) {
                    setErrorMsg((prev) => ({
                      ...prev,
                      DailyAmountIsInvalid: false,
                    }));
                    setDailyLimit(value);
                  }
                  // If invalid, do nothing (or you can show error)
                }}
                variant="outlined"
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                  },
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  // Remove spin buttons
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "& input[type=number]": {
                    MozAppearance: "textfield", // Firefox
                  },
                }}
              />
              {(errormsg.isInValidDaily ||
                errormsg.isDailyMorethanTotal ||
                errormsg.DailyAmountIsInvalid) && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>{ErrorMessage}</div>
                </div>
              )}
              {errormsg.isAnyFieldEmpty && DailyLimit == "" && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>
                    "Please enter a valid daily limit"
                  </div>
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={Note}
                type="text"
                disabled={store.isUserGlobalViewAdmin || store.isUserViewAdmin}
                label="Note"
                variant="outlined"
                // required
                InputProps={{
                  style: {
                    borderRadius: ".55rem",
                  },
                }}
                inputProps={{
                  maxLength: 55, // Change 100 to your desired limit
                }}
                onChange={(e) => {
                  setErrorMsg((prev) => ({ ...prev, invalidNote: false }));
                  setNote(e.target.value);
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                }}
              />
              {errormsg.invalidNote && (
                <div className={styles.errorDiv}>
                  <div className={styles.error}>{ErrorMessage}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.DateRangeContainer}>
          <div className={styles.addUserDetails11}>Select date</div>

          <div className={styles.label}>Start Date</div>
          <div className={styles.mobileMenu}>
            <input
              className={styles.field1}
              placeholder="Start Date & Time"
              type="datetime-local"
              value={startDate} // must be in "YYYY-MM-DDTHH:MM" format
              readOnly={
                store.TopUpStatus === "active" ||
                store.isUserGlobalViewAdmin ||
                store.isUserViewAdmin
              }
              min={getCurrentDateTime()} // returns "2025-12-01T14:30"
              onChange={(e) => {
                setErrorMsg((prev) => ({ ...prev, InvalidStartDate: false }));
                setErrorMsg((prev) => ({ ...prev, InvalidStartDate: false }));
                let value = e.target.value; // e.g., "2025-12-01T14:30"

                console.log("StartDateValue", value);
                value = value + ":00";
                // Clear endDate if start is after current end
                if (endDate && value > endDate) {
                  setEndDate("");
                }

                if (!minDate || value >= minDate) {
                  setStartDate(value);
                }
              }}
            />
          </div>
          {((errormsg.isAnyFieldEmpty && startDate == "") ||
            errormsg.InvalidStartDate) && (
            <div className={styles.errorDiv}>
              <div className={styles.error}>{ErrorMessage}</div>
            </div>
          )}
          <div className={styles.label}>End Date</div>
          <div className={styles.mobileMenu}>
            <input
              className={styles.field1}
              placeholder="End Date & Time"
              type="datetime-local"
              readOnly={
                store.isUserGlobalViewAdmin ||
                store.isUserViewAdmin
              }
              value={endDate} // should be "2025-12-31T23:59" format
              min={getEndDateMin()} // returns startDate or current time if already selected
              onChange={(e) => {
                setErrorMsg((prev) => ({
                  ...prev,
                  InvalidEndDate: false,
                }));

                let value = e.target.value; // e.g., "2025-12-31T18:30"
                console.log("EndDateValue", value);
                value = value + ":00";
                // Only allow if end >= start
                if (!startDate || value >= startDate) {
                  setEndDate(value);
                } else {
                  // Optional: show a toast/error that end cannot be before start
                  setErrorMsg((prev) => ({
                    ...prev,
                    InvalidEndDate: true,
                  }));
                  setErrorMessage("End Date can't be before start Date");
                }
              }}
            />
          </div>
          {((errormsg.isAnyFieldEmpty && endDate == "") ||
            errormsg.InvalidEndDate) && (
            <div className={styles.errorDiv}>
              <div className={styles.error}>{ErrorMessage}</div>
            </div>
          )}
        </div>
        <div className={styles.ButtonframeDiv}>
          {!store.isUserGlobalViewAdmin && !store.isUserViewAdmin ? (
            <div
              className={styles.ButtonSubmitCancel1}
              onClick={() => {
                OnFramButtonClicked();
              }}
            >
              Submit
            </div>
          ) : (
            <div
              className={styles.ButtonSubmitCancel1}
              onClick={() => {
                console.log("Button Is Disabled");
              }}
            >
              Submit
            </div>
          )}
        </div>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

TopUp.propTypes = {
  className: PropTypes.string,
};

export default TopUp;
